// JimDrawer — drawer flutuante do assistente operacional Jim.
// Wrapper fino sobre HydraDrawer que injeta config visual + agente='jim'.
// Visível apenas no módulo Operacional.
import HydraDrawer, { type AgenteConfig } from './HydraDrawer';
import IconJim from './IconJim';

const JIM_CONFIG: AgenteConfig = {
  agente: 'jim',
  nome: 'Jim',
  subtitulo: 'Assistente operacional · Claude Sonnet 4.5',
  corPrimaria: '#0a7f4a',
  gradiente: 'linear-gradient(135deg, #064a2e 0%, #0a7f4a 100%)',
  bubbleGradiente: 'linear-gradient(135deg, #0a7f4a 0%, #14B07E 100%)',
  bubbleSombra: '0 4px 16px rgba(10,127,74,0.35)',
  icone: <IconJim size={28} color="#fff" />,
  iconeHeader: <IconJim size={22} color="#fff" />,
  iconeVazio: <IconJim size={42} />,
  dicaTitulo: 'Olá! Sou o Jim.',
  dicaTexto:
    'Cuido da execução dos contratos com você (Gerente de Projetos).\nPergunte sobre prazos, alocação, recursos, clima das obras.',
  exemplos: [
    '"Como tá a carga da equipe na próxima semana?"',
    '"Quais contratos estão atrasados ou sem gestor?"',
    '"Vai chover quarta na obra do contrato HY26032?"',
    '"Preciso alocar drone semana que vem — quem tá livre?"',
  ],
  placeholder: 'Pergunte sobre projetos, alocação, prazos, clima...',
};

export default function JimDrawer() {
  return <HydraDrawer config={JIM_CONFIG} />;
}
